
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pc/[[...slug]]",
      function () {
        return require("private-next-pages/pc/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pc/[[...slug]]"])
      });
    }
  